import { App } from 'vue';
import __dev_log from "@/ts/__dev_log";

export default function addComponents(app: App): void {
    __dev_log.log('Not implemented', app)
}